import { avatarColor, initialsFor } from '../../pm/constants';

interface Props {
  email: string;
  size?: number;
}

const UserAvatar: React.FC<Props> = ({ email, size = 32 }) => {
  const bg = avatarColor(email);
  const initials = initialsFor(email);
  return (
    <span
      className="pm-avatar"
      style={{
        background: bg,
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
      }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
};

export default UserAvatar;
